import { PickerProps } from 'emoji-mart/dist-es'

import i18n from 'modules/core/lib/i18n'

export const translations: () => PickerProps['i18n'] = () => {
  return {
    categories: {
      activity: i18n.t('emojipicker.categories.activity'),
      custom: i18n.t('emojipicker.categories.custom'),
      flags: i18n.t('emojipicker.categories.flags'),
      foods: i18n.t('emojipicker.categories.foods'),
      nature: i18n.t('emojipicker.categories.nature'),
      objects: i18n.t('emojipicker.categories.objects'),
      people: i18n.t('emojipicker.categories.people'),
      places: i18n.t('emojipicker.categories.places'),
      recent: i18n.t('emojipicker.categories.recent'),
      search: i18n.t('emojipicker.categories.search'),
      symbols: i18n.t('emojipicker.categories.symbols'),
    },
    notfound: i18n.t('emojipicker.notfound'),
    search: i18n.t('emojipicker.search'),
  }
}
